import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h1>Dashboard</h1>
      <p>This is the content of the Dashboard page.</p>
    </div>
  );
};

export default Dashboard;